<template>
    <div v-if='value' class='w-100 mb-1 mt-1'>
        <template v-if='editable'>
            <div class='d-flex flex-row align-items-center'>
                <select @change='resetFilter' class='form-control form-control-sm w-auto mr-1' v-model="value.filter">
                    <option v-for="name in Object.keys(filters)">{{ name }}</option>
                </select>
                <template v-if='value.filter'>
                    <select v-if='Array.isArray(filters[value.filter].operands)' class='form-control form-control-sm w-auto mr-1' v-model="value.operand">
                        <option v-for="operand in filters[value.filter].operands">{{ operand }}</option>
                    </select>

                    <input v-if='filters[value.filter].type == "text"'' class='form-control form-control-sm w-auto mr-1' type="text" v-model='value.value'>
                    <input v-else-if='filters[value.filter].type == "numeric"'' class='form-control form-control-sm w-auto mr-1' type="number" min='0' v-model='value.value'>
                    <input v-else-if='filters[value.filter].type == "boolean"'' class='form-control form-control-sm w-auto mr-1' type="checkbox" v-model='value.value'>
                    <template v-else-if="filters[value.filter].type == 'tag'">
                        <div class='d-flex flex-row'>
                            <autocomplete class='align-self-stretch form-control'
                                    v-model='tag'
                                    ref='ac'
                                    :source="patientTags"
                                    @clear='tag = null'
                                    :resultsDisplay='tagResultDisplay'
                                    :request-headers="authHeaders"
                                    @selected='setDisplayValue'
                                    @close='setDisplayValue'
                                    >
                            </autocomplete>
                            <!-- <div v-if='tag' class='icon-preview'>
                                <i :class='"pr-1 fa fa-2x fa-" + tag.icon'></i>
                            </div> -->
                            <!-- <button :disabled='!tag' class="align-self-stretch btn btn-primary btn-sm text-white" v-on:click.prevent='addTag'>{{ $t('translations.add')}}</button> -->
                        </div>
                        <div>
                            <div :key='tag.tag_id' v-for='(tag, index) in value.value' class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                                <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                                <a v-on:click.prevent='value.value.splice(index,1)' href="#">&times;</a>
                            </div>
                        </div>
                    </template>
                    <select v-else-if="filters[value.filter].type == 'select'" class='form-control form-control-sm w-auto mr-1' v-model="value.value">
                        <option v-for="value in filters[value.filter].values" :value="value.id">{{ value.name }}</option>
                    </select>
                </template> 
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default() {
                return {};
            } 
        },
        filters: {
            default() {
                return {};
            } 
        },
        editable: {
            default: true,
        },
        showdescription: {
            default: true,
        },

    },
    data() {
        return {
            tag: null,
        };
    },
    computed: {
        charactersLeft() {
            if(typeof this.value.descriptive_text === 'string') {
                var char = this.value.descriptive_text.length;
                var limit = 1024;

                if(char > limit) {
                    this.value.descriptive_text = this.value.descriptive_text.substr(0, limit);
                    char = this.value.descriptive_text.length;
                }
                return (limit - char) + " " + this.$t('translations.characters_remaining');
            }
            return "";
        },
        authHeaders () {
            return {
                'Authorization': axios.defaults.headers.common['Authorization'],
                'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
            }
        },
        patientTags() {
            return this.$root.lookup.tags.filter(obj => {
                return obj.tags_tag_use.find(obj2 => {
                    return obj2.tag_use.name == 'client'
                })
            });
        }
            
    },
    watch: {
        
    },
    mounted() {
        //console.info(this.value);
        if(!this.value.filter) {
            Vue.set(this.value, 'filter', '');
            Vue.set(this.value, 'operand', '');
            Vue.set(this.value, 'value', '');
        }
    },
    methods: {
        clear() {
            this.value.filter = "";
            this.value.operand = "";
            this.value.value = "";
        },
        resetFilter() {
            switch(this.filters[this.value.filter].type) {
                case "boolean":
                    this.value.value = false;
                break;
                case "tag":
                    this.value.value = [];
                break;
                default:
                    this.value.value = "";
                break;
            }
            if(this.filters[this.value.filter].operands) {
                this.value.operand = this.filters[this.value.filter].operands[0];
            }
            else {
                this.value.operand = "";
            }

        },
        setDisplayValue() {
            Vue.nextTick(() => {
                if(this.$refs.ac.value) {
                    var tag = this.$root.lookup.tags.find(obj => {return obj.id == this.$refs.ac.value});
                    if(tag) {
                        //this.$refs.ac.display = tag.name;
                        this.addTag();
                        //this.$refs.ac.clear();

                    }
                }
            });
        },
        addTag() {
            if(!Array.isArray(this.value.value)) {
                this.value.value = [];
            }

            if(!this.value.value.find(obj => {return obj.tag_id == this.tag})) {
                this.value.value.push({tag_id: this.tag});
            }
            this.tag = null; 
            this.$refs.ac.clear();
        },
    },
};
</script>

<style scoped>
    .btn-clear {
        width: 22px; 
        height: 22px; 
        font-size: 13px; 
        padding: 0px;
        border: 1px solid #a0a0a0;
        border-radius: 0.25rem;
        font-weight: bold;
        color: rgb(120, 130, 140);
    }
</style>